import React from 'react';
import {Box, Grid} from "@mui/material";
import {Typography} from "@mui/joy";
import {useTranslation} from "react-i18next";
import {ContaminationDeclarationData} from "./types";

// Grey key/value tile — the #f4f4f4 / 4px surface the event drawer and hero
// cards use, with the uppercase micro-label from AssetSpecifications' headers.
const Tile = ({label, value}: {label: string; value?: string | null}) => (
    <Grid item xs={12} sm={6}>
        <Box sx={{backgroundColor: '#f4f4f4', borderRadius: '4px', p: '10px 12px', height: '100%'}}>
            <Typography
                level="body-xs"
                fontWeight="lg"
                sx={{color: '#666', textTransform: 'uppercase', letterSpacing: '0.6px'}}
            >
                {label}
            </Typography>
            <Typography level="bodyBold" sx={{color: value ? '#333' : '#999', mt: '2px', wordBreak: 'break-word'}}>
                {value || '–'}
            </Typography>
        </Box>
    </Grid>
);

// Nameplate + path as snapshotted by the backend at create time. Read-only on
// purpose: a live tree read would show where the asset is now, not where it
// picked up its contaminants.
const SnapshotBlock = ({declaration}: {declaration: ContaminationDeclarationData}) => {
    const {t} = useTranslation();
    return (
        <Box sx={{mb: '20px'}} data-testid="doc-snapshot">
            <Typography level="body-xs" sx={{color: 'text.tertiary', mb: '8px'}}>
                {t('Pre-filled from the asset record at the time of removal')}
            </Typography>
            <Grid container spacing={1.5}>
                <Tile label={t('Product')} value={declaration.productModelName}/>
                <Tile label={t('Serial No.')} value={declaration.serialNumber}/>
                <Tile label={t('Product code')} value={declaration.productCode}/>
                <Tile label={t('Installation Path')} value={declaration.installedBaseNodePath}/>
            </Grid>
        </Box>
    );
};

export default SnapshotBlock;
